import { PageTitle } from 'screens/OpenQuote/BaseComponents/PageTitle';
import AccessBackButton from '../BaseComponents/AccessBackButton';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccessCheckoutContext } from '../context/AccessCheckoutProvider';
import { useCartContext } from '../CartProvider';
import Loader from 'components/Loader';
import AccessCheckoutForm from './AccessCheckoutForm';
import Checkout from '../Checkout/Checkout';
import { observer } from 'mobx-react-lite';

const AccessCheckout = observer(() => {
  const cart = useCartContext();
  const navigate = useNavigate();
  const { locations, goToNext, goToPrevious, currentIndex } =
    useAccessCheckoutContext();

  const totalLocations = Math.max(locations.length, 1);
  const currentLocation = useMemo(
    () => locations[currentIndex],
    [currentIndex, locations],
  );

  const isNewLocation = currentLocation?.id === undefined;

  const onGoBack = () => navigate(-1);
  if (cart.loadingDraftForPricing) return <Loader className="w-full" />;

  return (
    <div className="flex w-full flex-col gap-6 bg-background-base-surface-1 p-6">
      <header className="flex justify-between">
        <div className="flex flex-col items-start gap-3">
          <AccessBackButton onClick={onGoBack} />
          <PageTitle title="Checkout" />
        </div>
        <div className="self-end rounded-[50px] bg-[rgba(151,150,243,0.16)] px-4 py-1">
          <span className="text-base font-bold text-[#9796F3]">
            {`${currentIndex + 1} of ${totalLocations}`}
          </span>
        </div>
      </header>
      {isNewLocation ? <Checkout /> : <AccessCheckoutForm />}
      {totalLocations > 1 && (
        <div className="flex gap-2 self-end">
          <GraniteButton
            className="w-full min-w-[175px]"
            size="medium"
            variant="secondary"
            onClick={goToPrevious}
            disabled={currentIndex === 0}
          >
            Previous location
          </GraniteButton>
          <GraniteButton
            className="w-full"
            size="medium"
            variant="tertiary"
            onClick={goToNext}
            disabled={currentIndex === totalLocations - 1}
          >
            Next location
          </GraniteButton>
        </div>
      )}
    </div>
  );
});

export default AccessCheckout;
